import React from "react";
import { FaSquarePhone } from "react-icons/fa6";
import Navbar from "../components/body_nav";

function Contact() {
  return (
    <>
      <Navbar title={"Contact"} icon={<FaSquarePhone />} />

      <div class="pt-3 pb-2 w-[95%]">
        <p class="text-lightgrey">
          I'm always open to new opportunities and collaborations. Whether you
          have a project in mind, a question, or just want to connect, feel free
          to reach out. I value meaningful conversations and am excited to hear
          about how we can work together to create something amazing. Please use
          the contact form below to get in touch, and I will respond as soon as
          possible.
        </p>
      </div>

      <div class="flex flex-col py-8 pr-4">
        {/* <div class="w-full max-w-md bg-gray-800 rounded-lg shadow-md p-6"> */}
        <h2 class="text-2xl font-bold text-lightgrey mb-4">Get In Touch</h2>

        <form class="flex flex-wrap">
          <input
            type="text"
            class="bg-lightgrey text-primary border-0 rounded-md p-2 mb-4 focus:bg-lightgrey focus:outline-none focus:ring-1 focus:ring-seagreen transition ease-in-out duration-150 w-full md:w-[48%] mr-[2%]"
            placeholder="Full Name"
          />
          <input
            type="email"
            class="bg-lightgrey text-darkgray border-0 rounded-md p-2 mb-4 focus:bg-lightgrey focus:outline-none focus:ring-1 focus:ring-seagreen transition ease-in-out duration-150 w-full md:w-[48%] ml-[2%]"
            placeholder="Email"
          />
          <input
            type="tell"
            class="bg-lightgrey text-darkgray border-0 rounded-md p-2 mb-4 focus:bg-lightgrey focus:outline-none focus:ring-1 focus:ring-seagreen transition ease-in-out duration-150 w-full md:w-[48%] mr-[2%]"
            placeholder="Phone Number"
          />
          <input
            type="text"
            class="bg-lightgrey text-darkgray border-0 rounded-md p-2 mb-4 focus:bg-lightgrey focus:outline-none focus:ring-1 focus:ring-seagreen transition ease-in-out duration-150 w-full md:w-[48%] ml-[2%]"
            placeholder="Company Name"
          />
          <input
            type="text"
            class="bg-lightgrey text-darkgray border-0 rounded-md p-2 mb-4 focus:bg-lightgrey focus:outline-none focus:ring-1 focus:ring-seagreen transition ease-in-out duration-150 w-full md:w-[48%] mr-[2%]"
            placeholder="Job Title"
          />
          <input
            type="date"
            class="bg-lightgrey text-darkgray border-0 rounded-md p-2 mb-4 focus:bg-lightgrey focus:outline-none focus:ring-1 focus:ring-seagreen transition ease-in-out duration-150 w-full md:w-[48%] ml-[2%]"
            placeholder="Date of Birth"
          />
          <textarea
            name="message"
            class="bg-lightgrey text-darkgray border-0 rounded-md p-2  mb-auto w-[100%] md:mb-auto md:w-full md:h-auto md:min-h-[100px] md:max-h-[100px] md:flex-grow md:flex-shrink md:flex-auto focus:bg-gray-md:focus:outline-none:focus:ring-blue-md:focus:border-transparent transition ease-in-out duration-fastest"
            placeholder="Message"
          ></textarea>

          <button
            type="submit"
            class="bg-seagreen text-primary font-bold py-2 px-4 rounded-md mt-4 hover:bg-darkgrey transition ease-in-out duration-150"
          >
            Submit
          </button>
        </form>
        {/* </div> */}
      </div>
    </>
  );
}

export default Contact;
